import allStores from "../stores/StoreLoader";

export function sb_hideAllAdminNavModals(exceptModal?: string) {
  if (exceptModal !== "editPage") {
    allStores.interfaceStore.stopEditingPage();
  }
}
